import { getAssignmentColor } from '@oberoninternal/travelbase-ds/constants/theme';
import { Box, Flex } from '@rebass/grid';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import ContentWrapper from './ContentWrapper';
import Stack from './Stack';

interface Props {
    leftChildren: ReactNode;
    rightChildren: ReactNode;
}

const TwoColumnIntro: FC<React.PropsWithChildren<Props>> = ({ leftChildren, rightChildren }) => (
    <StyledWrapper>
        <Grid>
            <Box flex={2}>
                <Stack style={{ maxWidth: '92.8rem' }} spacing={[6, null, 0]}>
                    {leftChildren}
                </Stack>
            </Box>
            <Box flex={1} my={[null, null, 'auto']} mt={[6, null, 0]}>
                {rightChildren}
            </Box>
        </Grid>
    </StyledWrapper>
);

export default TwoColumnIntro;

const StyledWrapper = styled(ContentWrapper)`
    && {
        padding-top: 2.4rem;
        @supports (padding-top: clamp(1px, 1px, 1px)) {
            padding-top: clamp(1.6rem, 3vw, 3.6rem);
        }
    }
`;
const Grid = styled(Flex)`
    display: flex;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        column-gap: 10rem;
        flex-direction: row;
    }
`;

const BaseList = styled.ul`
    padding: 0;
    svg {
        flex-shrink: 0;
    }
    li {
        margin-left: 0;
    }
`;

export const SocialsList = styled(BaseList)`
    margin-top: ${({ theme }) => theme.spacing['50_Semi']};
    > li {
        display: inline;
        + li {
            margin-left: 2.4rem;
        }
    }

    a {
        color: ${({ theme }) => getAssignmentColor(theme, theme.colorAssignments.main)};

        :hover {
            color: ${({ theme }) => getAssignmentColor(theme, theme.colorAssignments.main, 1)};
        }
    }
`;

export const PracticalList = styled(BaseList)`
    svg {
        color: ${({ theme }) => theme.colors.neutral['50']};
    }
    > li {
        display: flex;
        align-items: center;

        + li {
            margin-top: ${({ theme }) => theme.spacing['40_Standard']};
        }

        > * + * {
            margin-left: ${({ theme }) => theme.spacing['40_Standard']};
        }
    }

    a {
        word-break: break-word;
        text-decoration: none;
        color: ${({ theme }) => theme.colors.neutral['60']};
    }
`;
